import { baseApi } from "./baseApi";

export const presenceApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({

    getPresences: builder.query({
      query: ({
        page = 1, perPage = 10, search = "",
        status = "", date = "",
      } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        params.append("per_page", perPage);
        if (date)   params.append("date",   date);
        if (search) params.append("search", search);
        if (status) params.append("statut", status);
        return `/coach/presences?${params.toString()}`;
      },
      providesTags: ["Presences"],
    }),

    getStatistiquesCoach: builder.query({
      query: () => "/coach/statistiques",
      providesTags: ["Presences"],
    }),

    getStagiaires: builder.query({
      query: ({ search = "", per_page = 1000 } = {}) => {
        const params = new URLSearchParams();
        if (search) params.append("search", search);
        params.append("per_page", per_page);
        return `/coaches/stagiaires?${params.toString()}`;
      },
      transformResponse: (response) => {
        // ✅ Pagination Laravel : { current_page, data: [...], last_page, total }
        if (Array.isArray(response?.data))   return response.data;
        if (response?.stagiaires)            return response.stagiaires;
        if (response?.data?.data)            return response.data.data;
        if (Array.isArray(response))         return response;
        return [];
      },
      providesTags: ["Stagiaires"],
    }),

    getStagiaireById: builder.query({
      query: (id) => `/stagiaires/${id}`,
      providesTags: (result, error, id) => [{ type: "Stagiaires", id }],
    }),

    validatePointage: builder.mutation({
      query: (id) => ({
        url: `/ValidationPointages/${id}`,
        method: "POST",
      }),
      invalidatesTags: ["Presences"],
    }),

    // ✅ Désactivé si 500 — retourne stats vides pour éviter l'erreur
    getStagiaireMonthlyStats: builder.query({
      query: ({ userId, month, year }) =>
        `/coach/stagiaire/${userId}/monthly-stats?month=${month}&year=${year}`,
      providesTags: ["Stagiaires"],
      // ✅ Si 500 → retourner objet vide au lieu de propager l'erreur
      transformErrorResponse: () => ({
        statistics: { present: 0, absent: 0, retard: 0 },
        total_days: 0,
        present_rate: 0,
      }),
    }),
  }),
});

export const {
  useGetPresencesQuery,
  useGetStatistiquesCoachQuery,
  useGetStagiairesQuery,
  useGetStagiaireByIdQuery,
  useValidatePointageMutation,
  useGetStagiaireMonthlyStatsQuery,
} = presenceApi;